import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useMemo, useState } from 'react';

import ImageViewer from 'components/field/ImageViewer';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useLocale from 'hooks/useLocale';

import { OTOFLEX } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const ViewPOD = NiceModal.create(({ ID }) => {
	const axios = useAxiosPrivate();
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState([]);
	const { getLocaleDateWithTime } = useLocale();

	const columns = useMemo(
		() => [
			{
				header: 'proofType',
				accessorKey: 'proofType'
			},
			{
				header: 'createdDate',
				renderCell: ({ row }) => <Typography>{getLocaleDateWithTime(row?.original?.createdDate)}</Typography>
			},
			{
				header: 'photo',
				accessorKey: 'photo',
				renderCell: ({ row }) => <ImageViewer imageUrl={row?.original?.photo} />
			}
		],
		[]
	);
	const fetchFormData = () => {
		setLoading(true);
		axios
			.post(OTOFLEX.GET_PROOFS, { orderID: ID })
			.then((res) => {
				setFormData(res?.data);
			})
			.catch((error) => {
				AppLogger.error(error);
			})
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		ID && fetchFormData();
	}, [ID]);

	return (
		<Modal fullwidth maxWidth="large">
			<ModalTitle>
				<Typography variant="p1">proofPhotos</Typography>
			</ModalTitle>
			<ModalContent>
				<Table columns={columns} loading={loading} data={formData} />
			</ModalContent>
		</Modal>
	);
});

export default ViewPOD;
